export var showToastSuccessMessage = function (message, type, setSeeToastFunction) {
    setSeeToastFunction({
        show: true,
        message: message || "",
        type: type,
    });
};
